import { Injectable } from '@angular/core';
import { Http, Response, Headers, RequestOptions } from '@angular/http';
import 'rxjs/add/operator/map';
import { Observable } from 'rxjs/Observable';
import { Auth } from '../models/auth.model';
import { GLOBAL } from './global';

@Injectable()
export class AuthService{
   public url: string;

   constructor(
     public _http: Http
   )
   {
     this.url = GLOBAL.url;
   }

   checkUser(auth: Auth)
   {
     let json = JSON.stringify(auth);
     let params = 'json='+json;
     console.log(params);
     let headers = new Headers({'Content-Type':'application/x-www-form-urlencoded'});
     return this._http.post(this.url+'login',params, {headers:headers}).map(res => res.json());
   }

   getUserID(username:string,password:string)
   {
     return this._http.get(this.url+'user_id/'+username+'/'+password).map(res => res.json());
   }
}



// WEBPACK FOOTER //
// /home/isai/funeraria/src/app/services/auth.service.ts